import { useOpenWithFaireApplicationStatus } from "@faire/deprecated-retailer-visitor-shared/stores/domain/OpenWithFaire/useOpenWithFaireApplicationStatus";
import confirmIdentity from "@faire/web-api--source/routes/www/confirm-identity";
import underwritingInformation from "@faire/web-api--source/routes/www/underwriting-information";

export const useCompleteStoreProfileUrl = () => {
  const { hasPendingOwfUwRequest } = useOpenWithFaireApplicationStatus();

  return hasPendingOwfUwRequest ? underwritingInformation() : confirmIdentity();
};
